var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-btn-wrap"},_vm._l((this.tabTitle),function(item,index){return _c('button',{key:index,staticClass:"tab-btn-m",on:{"click":function($event){return _vm.tabItem(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }